import { Outlet } from 'react-router';

import { NotFound, getRoutesFromFiles } from '@sorare/routing';
import { Sport } from '@sorare/core/src/__generated__/globalTypes';
import {
  DialogKey,
  WithDialogs,
} from '@sorare/core/src/components/navigation/WithDialogs';
import { SportSwitcher } from '@sorare/core/src/contexts/sport/SportSwitcher';
import { lazy } from '@sorare/core/src/lib/retry';

/*
 * Prefer dynamic over static import into this file
 * because static ones will end up in the main bundle
 */
const GameViewDialog = lazy(
  async () => import('#src/components/game/GameViewDialog/index.tsx'),
  'GameViewDialog'
);

const So5LeaderboardContenderDialogFromParams = lazy(
  async () =>
    import('#src/components/lineup/So5LeaderboardContenderDialogFromParams/index.tsx'),
  'So5LeaderboardContenderDialogFromParams'
);

const MLBMarketSubscriptions = lazy(
  async () => import('#src/routing/MLBMarketSubscriptions/index.tsx'),
  'MLBMarketSubscriptions'
);
const DecisivePlayerPickerDialogFromParams = lazy(
  async () =>
    import('@sorare/gameplay/src/components/missions/picker/DecisivePlayerPickerDialogFromParams'),
  'DecisivePlayerPickerDialogFromParams'
);
const WithDialogLayout = () => {
  return (
    <WithDialogs
      dialogs={[
        {
          name: DialogKey.game,
          element: <GameViewDialog open />,
        },
        {
          name: DialogKey.contender,
          element: <So5LeaderboardContenderDialogFromParams />,
        },
        {
          name: DialogKey.decisivePlayerPicker,
          element: <DecisivePlayerPickerDialogFromParams />,
        },
      ]}
    >
      <SportSwitcher sport={Sport.BASEBALL} />
      <MLBMarketSubscriptions />
      <Outlet />
    </WithDialogs>
  );
};

const gamePlayFiles = Object.fromEntries(
  Object.entries(
    import.meta.glob('../../../gameplay/src/pages/**/(page|layout).tsx')
  ).map(([key, value]) => [
    key.replace('../../../gameplay/src/pages/', './'),
    value,
  ])
);

export const routeObjects = [
  {
    element: <WithDialogLayout />,
    children: [
      ...getRoutesFromFiles(
        { ...gamePlayFiles, ...import.meta.glob('./**/(page|layout).tsx') },
        '../../packages/baseball/src/pages'
      ),
      { path: '*', element: <NotFound /> },
    ],
  },
];
